app.controller(
    'AdminZoneTeamController', ['$scope', '$rootScope', '$http', '$stateParams', 'Configuration', 'UserService', '$translate', 'AdminService', AdminZoneTeamController]
);

function AdminZoneTeamController($scope, $rootScope, $http, $stateParams, Configuration, UserService, $translate, AdminService) {
    var vm = this;

    $scope.ZoneTeam = {
        ResponsableEditionFRList: [{ "name": "1" }, { "name": "2" }, { "name": "3" }, { "name": "4" }, { "name": "5" }],
        ResponsableEditionENList: [{ "name": "1" }, { "name": "2" }, { "name": "3" }, { "name": "4" }, { "name": "5" }],
        AuthorList: [{ "name": "1" }, { "name": "2" }, { "name": "3" }, { "name": "4" }, { "name": "5" }],
        TranslatorList: [{ "name": "1" }, { "name": "2" }, { "name": "3" }, { "name": "4" }, { "name": "5" }],
        CorrectorList: [{ "name": "1" }, { "name": "2" }, { "name": "3" }, { "name": "4" }, { "name": "5" }]
    };

    if ($stateParams.lang) {
        $scope.CurrentLang = $stateParams.lang;
    }
    else {
        $scope.CurrentLang = 'fr';
    }
    $translate.use($rootScope.LangForInterface);

    if ($stateParams.z) {
        vm.ParamZoneId = $stateParams.z;
    }
    else {
        vm.ParamZoneId = 1;
    }    

    initController();

    function initController() {
        getAdminZoneTeam(vm.ParamZoneId, $scope.CurrentLang);
    }

    function getAdminZoneTeam(zoneId, lang) {
        AdminService.getAdminZoneTeam(zoneId, lang)
            .then(function (zone) {
                $scope.ZoneTeam = zone.data;
                $rootScope.ZoneInfos = angular.copy(zone.data);
            });
    }

    vm.UpdateAdminCityTeam = function (zoneTeam) {
        AdminService.UpdateAdminCityTeam(zoneTeam)
                .then(
                    function success(data) { },
                    function error(data) { });
    }

    $scope.updateFieldTags = function () {

        $scope.$emit('updateFieldTags');
    };
}